import { includes } from 'lodash';
var routeMixin = {
    computed: {
        _isOrderConfirmation: function () {
            var routeName = this._getRouteName();
            return routeName.includes('order-confirmation');
        },
        _isCheckout: function () {
            var route = this._getRouteName();
            return route.includes('checkout');
        },
        _isItemRoute: function () {
            var routeName = this._getRouteName();
            return routeName.includes('item-detail');
        },
        _isGreetingRoute: function () {
            var routeName = this._getRouteName();
            return routeName.includes('greeting');
        },
        _isMenuCategory: function () {
            var routeName = this._getRouteName();
            return routeName.includes('category');
        },
        _isEditMode: function () {
            var route = this.$route;
            var params = route.params;
            var edit = !!(params.edit);
            return edit;
        },
        _isInitialStoreLoad: function () {
            var routeName = this._getRouteName();
            return routeName.includes('store');
        },
    },
    methods: {
        _getRouteName: function () {
            var route = this.$route;
            if (!route && !route.name) {
                return '';
            }
            var routeName = route.name.toLowerCase();
            return routeName;
        },
        whiteListRoute: function (list) {
            var route = this.$route;
            if (!route && !route.name) {
                return false;
            }
            var routeName = route.name;
            if (includes(list, routeName)) {
                return true;
            }
            return false;
        },
        blackListRoute: function (list) {
            return !this.whiteListRoute(list);
        },
    },
};
export default routeMixin;



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/routeMixin.ts
// module id = 1MC1
// module chunks = 18